import { Quality } from 'common';
import Data from 'data';
import Locale from 'data/locale';
import { itemDefenseRange } from './item';

const _L = Locale('acronyms');

const acronyms = {
  strength: '$1 str',
  energy: '$1 ene',
  dexterity: '$1 dex',
  vitality: '$1 vit',
  maxhp: '$1 life',
  maxmana: '$1 mana',
  maxstamina: '$1 stamina',
  item_armor_percent: '$1% def',
  tohit: '$1 ar',
  toblock: '$1% block',
  mindamage: '$1 min',
  maxdamage: '$1 max',
  secondary_mindamage: '$1 min',
  secondary_maxdamage: '$1 max',
  manarecoverybonus: '$1% mana reg',
  staminarecoverybonus: '$1% stamina reg',
  armorclass: '+$1 def',
  armorclass_vs_missile: '$1 missile def',
  armorclass_vs_hth: '$1 melee def',
  normal_damage_reduction: '$1 dr',
  magic_damage_reduction: '$1 mdr',
  damageresist: '$1% dr',
  magicresist: '$1% mdr',
  maxmagicresist: '$1% max magic res',
  fireresist: '$1 fr',
  maxfireresist: '$1 max fr',
  lightresist: '$1 lr',
  maxlightresist: '$1 max lr',
  coldresist: '$1 cr',
  maxcoldresist: '$1 max cr',
  poisonresist: '$1 pr',
  maxpoisonresist: '$1 max pr',
  firemindam: '$1 min fire',
  firemaxdam: '$1 max fire',
  lightmindam: '$1 min light',
  lightmaxdam: '$1 max light',
  magicmindam: '$1 min magic',
  magicmaxdam: '$1 max magic',
  coldmindam: '$1 min cold',
  coldmaxdam: '$1 max cold',
  poisonmindam: '$1 min psn',
  poisonmaxdam: '$1 max psn',
  lifedrainmindam: '$1 ll',
  manadrainmindam: '$1 ml',
  hpregen: '$1 repl',
  item_maxdurability_percent: '$1% dura',
  item_maxhp_percent: '$1% life',
  item_maxmana_percent: '$1% mana',
  item_attackertakesdamage: '$1 thorns',
  item_goldbonus: '$1% gold',
  item_magicbonus: '$1 mf',
  item_knockback: 'kb',
  item_addclassskills: '$1 $0',
  item_addexperience: '$1% exp',
  item_healafterkill: '$1 laek',
  item_reducedprices: '$1% prices',
  item_lightradius: '$1 light radius',
  item_req_percent: '$1% req',
  item_fasterattackrate: '$1 ias',
  item_fastermovevelocity: '$1 frw',
  item_nonclassskill: '$1 $0',
  item_fastergethitrate: '$1 fhr',
  item_fasterblockrate: '$1% fbr',
  item_fastercastrate: '$1 fcr',
  item_singleskill: '$1 $0',
  item_restinpeace: 'rip',
  item_poisonlengthresist: '$1% plr',
  item_normaldamage: '$1 dmg',
  item_howl: '$*flee',
  item_stupidity: '$*blinds',
  item_damagetomana: '$1% dtm',
  item_ignoretargetac: 'ignore def',
  item_fractionaltargetac: '$1% target def',
  item_preventheal: 'pmh',
  item_halffreezeduration: 'hfd',
  item_tohit_percent: '$1% ar',
  item_elemskill: '$1 $0',
  item_allskills: '$1 skills',
  item_freeze: '$*freeze',
  item_openwounds: '$1% ow',
  item_crushingblow: '$1% cb',
  item_manaafterkill: '$1 maek',
  item_deadlystrike: '$1% crit',
  item_absorbfire_percent: '$1% fire abs',
  item_absorbfire: '$1 fire abs',
  item_absorblight_percent: '$1% light abs',
  item_absorblight: '$1 light abs',
  item_absorbmagic_percent: '$1% magic abs',
  item_absorbmagic: '$1 magic abs',
  item_absorbcold_percent: '$1% cold abs',
  item_absorbcold: '$1 cold abs',
  item_slow: '$1% slow',
  item_aura: '$1 aura',
  item_indesctructible: 'indestructible',
  item_cannotbefrozen: 'cbf',
  item_addskill_tab: '$1 $0',
  item_numsockets: '$1 os',
  item_skillonattack: '$2% lvl $1 $0 on attack',
  item_skillonkill: '$2% lvl $1 $0 on kill',
  item_skillondeath: '$2% lvl $1 $0 on death',
  item_skillonhit: '$2% lvl $1 $0 on hit',
  item_skillonlevelup: '$2% lvl $1 $0 on lvlup',
  item_skillongethit: '$2% lvl $1 $0 on get hit',
  item_charged_skill: '$1 charges',
  item_armor_perlevel: 'def/lvl',
  item_armorpercent_perlevel: 'def%/lvl',
  item_hp_perlevel: '$*life/lvl',
  item_mana_perlevel: 'mana/lvl',
  item_maxdamage_perlevel: 'dmg/lvl',
  item_maxdamage_percent_perlevel: 'dmg%/lvl',
  item_strength_perlevel: 'str/lvl',
  item_dexterity_perlevel: 'dex/lvl',
  item_energy_perlevel: 'ene/lvl',
  item_vitality_perlevel: 'vit/lvl',
  item_tohit_perlevel: 'fools',
  item_tohitpercent_perlevel: 'visio',
  item_cold_damagemax_perlevel: 'cold/lvl',
  item_fire_damagemax_perlevel: 'fire/lvl',
  item_ltng_damagemax_perlevel: 'light/lvl',
  item_pois_damagemax_perlevel: 'psn/lvl',
  item_resist_cold_perlevel: 'cr/lvl',
  item_resist_fire_perlevel: 'fr/lvl',
  item_resist_ltng_perlevel: 'lr/lvl',
  item_resist_pois_perlevel: 'pr/lvl',
  item_absorb_cold_perlevel: 'coldabs/lvl',
  item_absorb_fire_perlevel: 'fireabs/lvl',
  item_absorb_ltng_perlevel: 'lightabs/lvl',
  item_absorb_pois_perlevel: 'psnabs/lvl',
  item_thorns_perlevel: 'thorns/lvl',
  item_find_gold_perlevel: 'gold/lvl',
  item_find_magic_perlevel: 'mf/lvl',
  item_crushingblow_perlevel: 'cb/lvl',
  item_openwounds_perlevel: 'ow/lvl',
  item_deadlystrike_perlevel: 'crit/lvl',
  item_replenish_durability: 'repl',
  item_replenish_quantity: 'repl',
  item_pierce_cold: '$1% cold pierce',
  item_pierce_fire: '$1% fire pierce',
  item_pierce_ltng: '$1% light pierce',
  item_pierce_pois: '$1% psn pierce',
  passive_fire_mastery: '$1% fire dmg',
  passive_ltng_mastery: '$1% light dmg',
  passive_cold_mastery: '$1% cold dmg',
  passive_pois_mastery: '$1% psn dmg',
  passive_fire_pierce: '$1% fire pierce',
  passive_ltng_pierce: '$1% light pierce',
  passive_cold_pierce: '$1% cold pierce',
  passive_pois_pierce: '$1% psn pierce',

  meta_ethereal: 'eth',
  meta_ethbugged: 'ebug',
  meta_totaldef: '$1 def',
  meta_reqlevel: '$1 lvl',
  meta_allstats: '$1 stats',
  meta_allres: '$1@',
  meta_dmgrange: '$1-$2 dmg',
  meta_firerange: '$1-$2 fire dmg',
  meta_coldrange: '$1-$2 cold dmg',
  meta_lightrange: '$1-$2 light dmg',
  meta_magicrange: '$1-$2 magic dmg',
  meta_poisonrange: '$1-$2 psn dmg',
  meta_dmgpercent: '$1% ed',
};

const acronym_gem = {
  gcv: 'ame',
  gfv: 'ame',
  gsv: 'ame',
  gzv: 'ame',
  gpv: 'p.ame',
  gcb: 'sap',
  gfb: 'sap',
  gsb: 'sap',
  glb: 'sap',
  gpb: 'p.sap',
  gcg: 'eme',
  gfg: 'eme',
  gsg: 'eme',
  glg: 'eme',
  gpg: 'p.eme',
  gcr: 'ruby',
  gfr: 'ruby',
  gsr: 'ruby',
  glr: 'ruby',
  gpr: 'p.ruby',
  gcw: 'dia',
  gfw: 'dia',
  gsw: 'dia',
  glw: 'dia',
  gpw: 'p.dia',
  gcy: 'top',
  gfy: 'top',
  gsy: 'top',
  gly: 'top',
  gpy: 'p.top',
  skc: 'sku',
  skf: 'sku',
  sku: 'sku',
  skl: 'sku',
  skz: 'p.sku',
};

const acronym_class = ['ama', 'sorc', 'nec', 'pala', 'barb', 'druid', 'assa'];
const acronym_tab = [
  'bow sk', 'p&m', 'java sk',
  'fire sk', 'light sk', 'cold sk',
  'curses', 'p&b', 'nec summ',
  'pc sk', 'off auras', 'def auras',
  'barb combat', 'masteries', 'warcries',
  'dru summ', 'shape sk', 'ele sk',
  'traps', 'shadow sk', 'martial arts'
];

function formatStat(stat, min, max, param) {
  let src = acronyms[stat];
  if (!src) return;
  if (min === max) src = src.replace('$1-$2', '$1');
  src = _L(src);
  return src.replace(/\$[012*]/g, sym => {
    if (sym === '$1') {
      return min;
    } else if (sym === '$2') {
      return max;
    } else if (sym === '$*') {
      return (min === 1 ? '' : min + ' ');
    } else {
      switch (stat) {
      case 'item_addclassskills': return _L(acronym_class[param] || '');
      case 'item_elemskill': return _L`fire sk`;
      case 'item_addskill_tab': return _L(acronym_tab[param] || '');
      default:
        const skill = Data.skills[param];
        const skilldesc = skill && Data.skillDesc[skill.skilldesc];
        return Locale.strings[skilldesc?.strname]?.toLowerCase() || '';
      }
    }
  });
}

export function formatRBF(item) {
  const uniq = Data.uniqueItems[item.unique];
  if (!uniq) return;
  let name;
  switch (uniq.prop1) {
  case 'dmg-ltng': name = 'light'; break;
  case 'dmg-cold': name = 'cold'; break;
  case 'dmg-fire': name = 'fire'; break;
  case 'dmg-pois': name = 'psn'; break;
  default: return;
  }
  name += (uniq.prop4 === 'death-skill' ? ' die' : ' up');
  const val = item.uniqueValues;
  if (!val) return name;
  return `${_L(name)} -${val[1]}/+${val[2]}`;
}
function formatTorch(item) {
  const val = item.uniqueValues || [];
  return `${_L(acronym_class[val[0]])} ${val[1]}/${val[2]}`;
}
function formatAnni(item) {
  const val = item.uniqueValues || [];
  return `${val[1]}/${val[2]}/${val[3]}`;
}

export function itemCreateDescription(item, stats, fixedStats) {
  if (item.quality === Quality.UNIQUE) {
    if (item.base === 'jew') return formatRBF(item);
    if (item.base === 'cm2') return formatTorch(item);
    if (item.base === 'cm1') return formatAnni(item);
  }

  const base = Data.items[item.base];
  if (!base) return null;

  if (item.quality === Quality.RUNEWORD) {
    delete stats.item_numsockets;
  } else if (item.sockets) {
    stats.item_numsockets = item.sockets - (item.socketedItems?.length || 0);
  }

  if (fixedStats) {
    for (const id in fixedStats) {
      if (stats[id] && fixedStats[id] < stats[id]) {
        stats[id] -= fixedStats[id];
      } else if (fixedStats[id] === stats[id]) {
        delete stats[id];
      }
    }
  }

  const lines = [];

  if (stats.strength && stats.energy === stats.strength && stats.dexterity === stats.strength && stats.vitality === stats.strength) {
    lines.push([Data.itemStatCost.energy.descpriority, formatStat('meta_allstats', stats.strength)]);
    delete stats.strength;
    delete stats.energy;
    delete stats.dexterity;
    delete stats.vitality;
  }

  if (stats.fireresist && stats.lightresist === stats.fireresist && stats.coldresist === stats.fireresist && stats.poisonresist === stats.fireresist) {
    lines.push([Data.itemStatCost.poisonresist.descpriority, formatStat('meta_allres', stats.fireresist)]);
    delete stats.fireresist;
    delete stats.lightresist;
    delete stats.coldresist;
    delete stats.poisonresist;
  }

  if (stats.mindamage && stats.maxdamage) {
    lines.push([Data.itemStatCost.maxdamage.descpriority, formatStat('meta_dmgrange', stats.mindamage, stats.maxdamage)]);
    delete stats.mindamage;
    delete stats.maxdamage;
  }

  if (stats.firemindam && stats.firemaxdam) {
    lines.push([Data.itemStatCost.firemaxdam.descpriority, formatStat('meta_firerange', stats.firemindam, stats.firemaxdam)]);
    delete stats.firemindam;
    delete stats.firemaxdam;
  }

  if (stats.coldmindam && stats.coldmaxdam) {
    lines.push([Data.itemStatCost.coldmaxdam.descpriority, formatStat('meta_coldrange', stats.coldmindam, stats.coldmaxdam)]);
    delete stats.coldmindam;
    delete stats.coldmaxdam;
    delete stats.coldlength;
  }

  if (stats.lightmindam && stats.lightmaxdam) {
    lines.push([Data.itemStatCost.lightmaxdam.descpriority, formatStat('meta_lightrange', stats.lightmindam, stats.lightmaxdam)]);
    delete stats.lightmindam;
    delete stats.lightmaxdam;
  }

  if (stats.magicmindam && stats.magicmaxdam) {
    lines.push([Data.itemStatCost.magicmaxdam.descpriority, formatStat('meta_magicrange', stats.magicmindam, stats.magicmaxdam)]);
    delete stats.magicmindam;
    delete stats.magicmaxdam;
  }

  if (stats.poisonmindam && stats.poisonmaxdam && stats.poisonlength) {
    let length = stats.poisonlength;
    if (stats.poison_count) length /= stats.poison_count;
    lines.push([Data.itemStatCost.poisonmaxdam.descpriority, formatStat('meta_poisonrange', Math.round(stats.poisonmindam * length / 256), Math.round(stats.poisonmaxdam * length / 256))]);
    delete stats.poisonmindam;
    delete stats.poisonmaxdam;
    delete stats.poisonlength;
    delete stats.poison_count;
  }

  if (stats.item_mindamage_percent && stats.item_maxdamage_percent === stats.item_mindamage_percent) {
    lines.push([Data.itemStatCost.item_mindamage_percent.descpriority, formatStat('meta_dmgpercent', stats.item_mindamage_percent)]);
    delete stats.item_mindamage_percent;
    delete stats.item_maxdamage_percent;
  }

  for (const idFull in stats) {
    let [id, param, param2] = idFull.split('#');
    const stat = Data.itemStatCost[id];
    if (!stat || !acronyms[id]) continue;
    let value = stats[idFull];
    if (!value && param2 !== 'x') continue;
    let priority = stat.descpriority;
    if (param) priority += parseInt(param) * 0.000001;
    if (param2 === 'x') {
      param2 = param;
      param = value;
      value = param2;
      param2 = null;
    }

    switch (stat.descfunc) {
    case 5: case 10:
      value *= 100 / 128;
      break;
    case 11: // Repairs 1 Durability In [100 / value] Seconds
      value = 100 / value;
      break;
    case 20:
    case 21:
      value = -value;
      break;
    // no default
    }
    if (stat.descfunc >= 6 && stat.descfunc <= 10) {
      value = parseFloat((value / (1 << stat.opparam)).toFixed(3));
    } else if (typeof value === 'number') {
      value = value.toFixed(0);
    }
    lines.push([priority, formatStat(id, value, param2, param)]);
  }

  const defRange = itemDefenseRange(item);
  if (defRange && defRange.minac < defRange.maxac && item.defense) {
    let def = item.defense;
    if (item.ethereal || item.stats?.item_ethereal) {
      def += Math.floor(def * 0.5);
      if (item.ethbugged) def += Math.floor(def * 0.5);
    }
    if (item.quality === Quality.LOW) {
      def = Math.floor(def * 0.75);
    }
    if (item.stats.item_armor_percent) {
      def += (def * (item.stats.item_armor_percent || 0) / 100) | 0;
    }
    if (item.stats.armorclass) {
      def += item.stats.armorclass;
    }
    lines.push([1000, formatStat('meta_totaldef', def)]);
  }

  if (item.ethereal) {
    if (item.ethbugged) {
      lines.push([0, formatStat('meta_ethbugged', 1)]);
    } else {
      lines.push([0, formatStat('meta_ethereal', 1)]);
    }
  }

  return lines.sort((a, b) => b[0] - a[0]).map(line => line[1]).join(' ');
}

export function itemGetDescription(item, items) {
  if (!items || item.quality === Quality.RUNEWORD || !item.socketedItems?.length) return item.description;
  return [
    item.description,
    ...item.socketedItems.map(id => {
      const gem = Data.gems[id];
      if (gem) {
        return gem.letter ? gem.letter.toLowerCase() : _L(acronym_gem[id] || '');
      } else {
        return items[id]?.description;
      }
    })
  ].filter(Boolean).join(' + ');
}
